import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentService } from '@core/payments/services/payment.service';
import { LoaderService } from '@shared/services/loader.service';
import { SignJWT } from 'jose';

@Component({
    selector: 'app-pin-page',
    templateUrl: './pin-page.component.html',
    styleUrls: ['./pin-page.component.css'],
    standalone: false
})
export class PinPageComponent implements OnInit {
  public errorcode = false;
  input1: string = '';
  input2: string = '';
  input3: string = '';
  input4: string = '';
  input5: string = '';
  input6: string = '';
  public email: string = '';
  isButtonDisabled: boolean = false;
  isTransactionDeclined: boolean = false;
  isUploadCard: Boolean = false;

  constructor(
    private _paymentService: PaymentService,
    private _loadService: LoaderService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isUploadCard = this._paymentService.uploadcard;
    this.enviocorreo();
    this.email = this._paymentService.email;

    if (this._paymentService.requestpayment.result.status === 'DECLINED') {
      this.isTransactionDeclined = true;
    }
  }

  disableButton(): void {
    this._paymentService.finishpin = true;
    console.log('se deshabilito el boton');
    this.isButtonDisabled = true;
    this.router.navigate(['/confirmationDAM'], { replaceUrl: true });
  }
  
 // Función que distribuye los caracteres pegados
  handlePaste(event: ClipboardEvent): void {
    event.preventDefault(); // Evitar el comportamiento por defecto del pegado

    const clipboardData = event.clipboardData?.getData('text');
    const inputs = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];

    if (clipboardData) {
      // Obtener los caracteres pegados y asignarlos a los campos
      const chars = clipboardData.slice(0, inputs.length).split('');
      // Iterar sobre los caracteres pegados y asignarlos a los inputs correspondientes
      chars.forEach((char, index) => {
        const input = document.getElementById(inputs[index]) as HTMLInputElement;
        if (input) {
          input.value = char; // Asignar el valor pegado
          (this as any)[inputs[index]] = char; // Actualizar el modelo ngModel
        }
      });
      // Mover el foco al siguiente campo después del último valor pegado
      const lastFilledInput = inputs[chars.length - 1];
      const nextInput = document.getElementById(lastFilledInput) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  enforceMaxLength(event: any, nextElementId: string | null): void {
    const input = event.target as HTMLInputElement;
 
    // Limit 1 character
    if (input.value.length > 1) {
      input.value = input.value.slice(0, 1);
    }
 
    // Focus the next valid value
    if (input.value.length === 1 && nextElementId) {
      const nextInput = document.getElementById(nextElementId);
      if (nextInput) {
        nextInput.focus();
      }
    }
  }
 
  async verificarpin() {
    const pin = `${this.input1}${this.input2}${this.input3}${this.input4}${this.input5}${this.input6}`;
    if (pin.length === 6) {
      const secretKey = new TextEncoder().encode(localStorage.getItem('clnum') as string);
      const payload = {
        correo: this._paymentService.email,
        pintoken: pin,
        phoneNumber: localStorage.getItem('phoneNumber'),
        clnum: localStorage.getItem('clnum'),
      }
      const jwt = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setExpirationTime('1h')
      .sign(secretKey);
      this._paymentService.hashSHA256('c3n4ms3rv1c3').then((hash) => {
        this._paymentService.hashSHA256('cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ=='+hash).then((hasht) => {
          const auth = this._paymentService.getAuthToken();
          this._paymentService.ValidateToken(hasht, jwt, auth).subscribe((res) => {
            if (
              res.validarTokenCorreoResponse.AcknowledgementDescription ===
              'Token valido'
            ) {
              this._paymentService.finishpin = false;
              this.router.navigate(['/confirmationDAM'], { replaceUrl: true });
            } else {
              this.errorcode = true;
              setTimeout(() => {
                this.errorcode = false;
              }, 1000);
            }
            this._loadService.hideLoading();
          },
          (error) => {
            this.errorcode = true;
            setTimeout(() => {
              this.errorcode = false;
            }, 1000);
            this._loadService.hideLoading();
          });
        });
      });
    } else {
      this.errorcode = true;
      setTimeout(() => {
        this.errorcode = false;
      }, 1000);
      console.log('error en el pin');
    }
  }
 
  async enviocorreo(): Promise<void> {
    try {
      const secretKey = new TextEncoder().encode(localStorage.getItem('clnum') as string);
      const payload = {
        correo: this._paymentService.email,
        phoneNumber: localStorage.getItem('phoneNumber'),
        clnum: localStorage.getItem('clnum'),
      }
      const jwt = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setExpirationTime('1h')
      .sign(secretKey);
      const hash = await this._paymentService.hashSHA256('c3n4ms3rv1c3');
      const hasht = await this._paymentService.hashSHA256('cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ==' + hash);
      const auth = this._paymentService.getAuthToken();
      const emailResponse = await this._paymentService.GenerateToken(jwt, hasht, auth).toPromise();

      if (emailResponse.generateTokenCorreoResponse.AcknowledgementIndicator === 'SUCCESS') {
        this._loadService.hideLoading();
      } else {
        this._paymentService.finishpin = true;
        this.router.navigate(['/confirmationDAM'], { replaceUrl: true });
      }
    } catch (error) {
      this._paymentService.finishpin = true;
      this.router.navigate(['/confirmationDAM'], { replaceUrl: true });
    }
  }
  
  // async updateCardService() {
  //   try {
  //     const resultUbindCard = await this.unbindCard(
  //       this._paymentService.bodyrequestcard
  //     );
  //     console.log(resultUbindCard);
  //     if (resultUbindCard.resultCode === 'SUCCESS') {
  //       console.log(this._paymentService.email);
  //       this._paymentService.finishpin = false;
  //       this.router.navigate(['/confirmationDAM']);
  //     } else {
  //       console.log('ERROR RESULTADO NO EXITOSO');
  //       this._paymentService.finishpin = true;
  //       this.router.navigate(['/confirmationDAM']);
  //     }
  //   } catch (error) {
  //     console.log('ERROR GENERAL AL ACTUALIZAR TARJETA');
  //     this._paymentService.finishpin = true;
  //     this.router.navigate(['/confirmationDAM']);
  //   }
  // }

  // unbindCard(bodyRequest?: any): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     const extractedData = {
  //       rfc: this._paymentService.numberphone,
  //       toke_numero: this._paymentService.tokeNumero,
  //       transientToken: bodyRequest.transientToken,
  //       captureContext: bodyRequest.captureContext,
  //     };

  //     this._paymentService.unbindCardPayment(extractedData).subscribe(
  //       (transactionSummary) => {
  //         console.log(extractedData);
  //         const { resultCode, result } = transactionSummary;
  //         console.log(resultCode, result);
  //         console.log(transactionSummary);

  //         if (transactionSummary.errorCode) {
  //           this._paymentService.setIsNational(false);
  //         }
  //         resolve(transactionSummary);
  //       },
  //       (error) => {
  //         reject(error);
  //       }
  //     );
  //   });
  // }
}
